export default class Course {
  constructor(API) {
    this.api = API;
  }
  /*
  {
    id: 'validString',
    certificationID: 'validString',
    tenantID: 'validString',
    customerID: 'validString',
    sharedModuleClassroomAPIKey: 'validString',
    productID: 'validString',
    coolDownPeriod: ['number'], 'number', 'null?',
    maxRetry: 'number',
    requirementsIDs: ['validString'],
    requiredOnRenew: 'boolean',
    validityPeriod: 'number',
    warningDuePaymentRemainingDays: 'number',
    warningRemainingDays: 'any',
    onlineWarningRemainingDays: 'any',
    displayName: 'validString',
    description: 'validString',
    uiTerm: 'validString',
    uiLogo: 'validString',
    v1: 'any?',
    createdBy: 'any?',
    updatedBy: 'any?',
    updatedOn: 'any?',
    createdOn: 'any?',
    transactionID: 'any?',
  }
  */
  async getAllCourses() {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/courses/';
    return await req.exec();
  }
}
